import React from "react";

const IconScrollChevron = () => (
	<svg className="IconScrollChevron" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
		<path d="M8.82 1.91L5 5.731l-3.82-3.82L0 3.09l5 5 5-5-1.18-1.18z" fill="#fff"/>
	</svg>
);

export default IconScrollChevron;
